import { gsap, ScrollTrigger } from "@gsap";

function initTextStats() {

	const format = new Intl.NumberFormat(document.documentElement.lang || "nl-NL");

	document.querySelectorAll(".text_stats-layout [data-count-to]").forEach((el) => {
		if (el.dataset.countInit) return;
		el.dataset.countInit = "true";

		const target = parseFloat(el.dataset.countTo) || 0;

		gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
			const counter = { value: 0 };
			el.textContent = format.format(0);

			const tween = gsap.to(counter, {
				value: target,
				duration: 1.6,
				ease: "power2.out",
				paused: true,
				onUpdate: () => (el.textContent = format.format(Math.round(counter.value))),
			});

			const trigger = ScrollTrigger.create({ trigger: el, start: "top 90%", once: true, onEnter: () => tween.play() });

			return () => {
				trigger.kill();
				tween.kill();
				el.textContent = format.format(target);
			};
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initTextStats);
} else {
	initTextStats();
}
